"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { FilterChip, TRANSFORMER_MAX_MOBILE_WIDTH_PX } from "@pcln/horizon";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
const CITY_INPUT_LABEL = 'Where to?';
const CITY_PANEL_CLASS = 'absolute top-full left-0 z-20 mt-2 w-[464px] max-w-[calc(100vw-2rem)]';
const AUTOCOMPLETE_POPUP_SELECTOR = '[data-base-autocomplete-popup]';
function AiSearchCityChip({ city, renderAutocomplete, onCityChange }) {
    const isMobile = useMediaQuery({
        maxWidth: TRANSFORMER_MAX_MOBILE_WIDTH_PX
    });
    const [isOpen, setIsOpen] = useState(false);
    const inputRef = useRef(null);
    const chipRef = useRef(null);
    useEffect(()=>{
        if (isOpen) inputRef.current?.focus();
    }, [
        isOpen
    ]);
    useEffect(()=>{
        if (!isOpen) return;
        const handlePointerDown = (event)=>{
            const target = event.target;
            if (!(target instanceof Element)) return;
            if (target.closest(AUTOCOMPLETE_POPUP_SELECTOR)) return;
            if (chipRef.current?.contains(target)) return;
            setIsOpen(false);
        };
        document.addEventListener('pointerdown', handlePointerDown);
        return ()=>{
            document.removeEventListener('pointerdown', handlePointerDown);
        };
    }, [
        isOpen
    ]);
    const handleKeyDown = useCallback((event)=>{
        if ('Escape' !== event.key) return;
        if (inputRef.current?.getAttribute('aria-expanded') === 'true') return;
        setIsOpen(false);
    }, []);
    const handleItemSelect = useCallback((nextCity)=>{
        if (!nextCity) return;
        onCityChange?.(nextCity);
        setIsOpen(false);
    }, [
        onCityChange
    ]);
    const handleChipClick = useCallback(()=>{
        setIsOpen((open)=>!open);
    }, []);
    const setInputRef = useCallback((element)=>{
        inputRef.current = element;
    }, []);
    const renderChipTrigger = useCallback(({ isOpen: isDrawerOpen, onClick, onMouseDown, ...triggerProps })=>/*#__PURE__*/ jsx(FilterChip, {
            ...triggerProps,
            label: city.itemName,
            opens: false,
            type: "chip",
            filterType: "radio",
            emphasis: "regular",
            showCheckIcon: false,
            selected: isDrawerOpen,
            className: "openable-filter-chip",
            onClick: onClick,
            onMouseDown: onMouseDown
        }), [
        city.itemName
    ]);
    const autocomplete = renderAutocomplete({
        searchKey: 'aiSearchCity',
        label: CITY_INPUT_LABEL,
        typeAheadEndpoint: 'hotels',
        initialSelectedItem: city,
        onItemSelect: handleItemSelect,
        inputRef: setInputRef,
        renderTrigger: renderChipTrigger
    });
    if (isMobile) return /*#__PURE__*/ jsx("div", {
        "data-testid": "ai-search-city-chip",
        children: autocomplete
    });
    return /*#__PURE__*/ jsxs("div", {
        className: "relative",
        "data-testid": "ai-search-city-chip",
        ref: chipRef,
        children: [
            /*#__PURE__*/ jsx(FilterChip, {
                label: city.itemName,
                opens: false,
                type: "chip",
                filterType: "radio",
                emphasis: "regular",
                showCheckIcon: false,
                selected: isOpen,
                className: "openable-filter-chip",
                onClick: handleChipClick
            }),
            isOpen ? /*#__PURE__*/ jsx("div", {
                className: CITY_PANEL_CLASS,
                onKeyDown: handleKeyDown,
                children: autocomplete
            }) : null
        ]
    });
}
export { AiSearchCityChip };
